import { Group, Text } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const sizes = {
  sm: { icon: 20, text: 'md' as const },
  md: { icon: 28, text: 'lg' as const },
  lg: { icon: 36, text: 'xl' as const },
};

export function Logo({ size = 'md', showText = true }: LogoProps) {
  const { icon, text } = sizes[size];

  return (
    <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
      <Group gap="xs">
        <IconShoppingCart size={icon} stroke={2} color="var(--mantine-color-brand-6)" />
        {showText && (
          <Text size={text} fw={700}>
            CartCritic
          </Text>
        )}
      </Group>
    </Link>
  );
}
